import { createSlice } from "@reduxjs/toolkit"

import {
  setProjectPendingHandler,
  unsetProjectPendingHandler
} from "./projectsActionsHandlers"
import { ProjectsReducerState } from "./types"

const initialState: ProjectsReducerState = {}

const projectsSlice = createSlice({
  name: "projects",
  initialState,
  reducers: {
    setProjectPending: setProjectPendingHandler,
    unsetProjectPending: unsetProjectPendingHandler
  }
})

export const { setProjectPending, unsetProjectPending } = projectsSlice.actions

const { actions } = projectsSlice

export { actions }

export default projectsSlice.reducer
